export default __webpack_public_path__ + "static/media/18.6b69c191.png";